import { render, staticRenderFns } from "./DocHubManager.vue?vue&type=template&id=025f5f1a"
import script from "./DocHubManager.vue?vue&type=script&lang=js"
export * from "./DocHubManager.vue?vue&type=script&lang=js"
import style0 from "./DocHubManager.vue?vue&type=style&index=0&id=025f5f1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports